import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FrameViewConfig } from '../../models/componentContract.model';
import { DynamicComponent } from '../../models/dynamicComponent.interface';

@Component({
  selector: 'app-frame-view-config',
  templateUrl: './frame-view-config.component.html',
  styleUrls: ['./frame-view-config.component.scss'],
})
export class FrameViewConfigComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      component: DynamicComponent;
      config: FrameViewConfig;
    }
  ) {}

  onRefresh() {
    this.data.component.updateDataSource();
  }
}
